<template>
  <div class="container public">
    <div class="row justify-content-center">
      <div v-if="currentCompany.backendMode" class="col-12 col-sm-8 col-md-6 col-lg-4 mx-auto">
        <logo/>
        <p>This is just the backend. No client functions!</p>
      </div>
      <div v-else class="col-12 col-sm-8 col-md-6 col-lg-4 mx-auto py-4">
        <!-- /demo entry: hide the forms while the automatic demo login runs;
             on failure autoDemo flips back and the normal page shows the error -->
        <div v-if="autoDemo" class="form">
          <logo/>
          <p class="text-center demo-starting">{{ $t('loginPage.autoDemoStarting') }}</p>
        </div>
        <div v-else class="form">
          <logo/>
          <form @submit.prevent="submitForm">
            <error-row @clearError="clearError" :errorMessage="errorMessage" />
            <div class="form-group" v-if="showOrganizationPopup">
              <label for="organization">{{ $t('loginPage.form.organization.label') }}</label>
              <select class="form-control" id="organization" v-model="form.organization" >
                <option v-for="org in organizations" :value="org.code" :key="org.code">
                  {{ org.name }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label for="username">{{ $t('loginPage.form.username.label') }}</label>
              <input type="text" class="form-control" :class="{ 'is-invalid': v$.form.username.$dirty && v$.form.username.$error }" id="username" v-model.trim="form.username">
              <div class="invalid-feedback" v-if="v$.form.username.$dirty">
                <div v-if="!v$.form.username.required">{{ $t('loginPage.form.username.required') }}</div>
              </div>
            </div>
            <div class="form-group">
              <label for="password">{{ $t('loginPage.form.password.label') }}</label>
              <input type="password" class="form-control" :class="{ 'is-invalid': v$.form.username.$dirty && v$.form.password.$error }" id="password" v-model="form.password">
              <div class="invalid-feedback" v-if="v$.form.password.$dirty">
                <div v-if="!v$.form.password.required">{{ $t('loginPage.form.password.required') }}</div>
              </div>
            </div>
            <div class="form-group">
              <label for="org-code">{{ $t('loginPage.form.org-code.label') }}</label>
              <input type="text" class="form-control" :class="{ 'is-invalid': v$.form.organization.$dirty && v$.form.organization.$error }" id="org-code" v-model.trim="form.organization">
              <div class="invalid-feedback" v-if="v$.form.organization.$dirty">
                <div v-if="!v$.form.organization.required">{{ $t('loginPage.form.organization.required') }}</div>
              </div>
            </div>
            <div>
              <p></p>
              <button type="submit" class="btn btn-primary w-100">{{ $t('loginPage.form.submit') }}</button>
            </div>
          </form>
          <div class="forgotten">
            <div class="form-group">
              <button id="forgotten" @click="passwordForgotten" class="btn btn-secondary w-100">{{ $t('loginPage.form.forgotten.button') }}</button>
            </div>
          </div>
          <div>
            <form @submit.prevent="submitDemoForm">
              <br>
              <hr>
              <button type="submit" class="btn btn-primary w-100">{{ $t('loginPage.form.submitDemo') }}</button>
            </form>
          </div>
    <!--
          <div class="pricing-link">
            <router-link :to="{ name: 'pricing' }">Preise &amp; Pakete ansehen</router-link>
          </div>
    -->
        </div>
        <div class="row justify-content-center">
          <p></p>
          <!-- <center> was an obsolete element: Vue 3 does not know the tag,
               tried to resolve it as a component and warned on every render. -->
          <div class="text-center">
            <span class="float-left" v-if="currentCompany.ios.length && currentCompany.android.length">
                <a :href="currentCompany.ios"> <img src="images/Download-ON-The-App-Store-Badge-DE.png" height="50"></a>
            </span>
            <span class="float-center" v-if="currentCompany.ios.length && !currentCompany.android.length">
                <a :href="currentCompany.ios"> <img src="images/Download-ON-The-App-Store-Badge-DE.png" height="50"></a>
            </span>
            <span class="float-center" v-if="currentCompany.android.length && !currentCompany.ios.length">
                <a :href="currentCompany.android"> <img src="images/GetItOnGooglePlay_Badge_Web_color_German.png" height="49"></a>
            </span>
            <span class="float-right" v-if="currentCompany.android.length && currentCompany.ios.length">
                <a :href="currentCompany.android"> <img src="images/GetItOnGooglePlay_Badge_Web_color_German.png" height="49"></a>
            </span>
          </div>
        </div>
      </div>
    </div>
    <page-footer/>
    <password-forgotten v-if="showForgottenModal" :company="company" :suggestedUserName="form.username" @close="closeForgottenModal" />
  </div>
</template>

<script>
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import authenticationService from '@/services/authentication'
// import { mapGetters } from 'vuex'
import Logo from '@/components/Logo.vue'
import ErrorRow from '@/components/ErrorRow.vue'
import PageFooter from '@/components/PageFooter.vue'
import PasswordForgottenModal from '@/modals/PasswordForgottenModal.vue'
import { closeAllModals } from '@/utils/modals'

export default {
  setup () { return { v$: useVuelidate() } },
  name: 'LoginPage',
  data: function () {
    return {
      form: {
        organization: '',
        username: '',
        password: ''
      },
      showOrganizationPopup: false,
      showForgottenModal: false,
      autoDemo: false,
      errorMessage: '',
      currentCompany: { logo: 'CHL_Logo.png', name: 'CHL', short: 'CHL', backendMode: false, build: '', ios: '', android: '' }
    }
  },
  components: {
    logo: Logo,
    'password-forgotten': PasswordForgottenModal,
    'error-row': ErrorRow,
    'page-footer': PageFooter
  },
  watch: {
    company () {
      /* eslint-disable no-console */
      console.log('backendMode: ' + this.company.backendMode)
    }
  },
  validations: {
    form: {
      organization: {
        required
      },
      username: {
        required
      },
      password: {
        required
      }
    }
  },
  mounted () {
    // catch-all: if the session expired while a dialog was open, its
    // Bootstrap backdrop survives the route change and covers this page
    closeAllModals()
    this.loadCompanyValues()
    const params = this.$route.query
    if (params) {
      if (params.organization) {
        this.form.organization = params.organization
      }
      if (params.username) {
        this.form.username = params.username
      }
      if (params.password) {
        this.form.password = params.password
      }
    }
    if (this.company != null) {
      /* eslint-disable no-console */
      console.log(this.company)
    }
    // /demo deep link (e.g. from the CleverSolutionLab site): log the demo
    // user in without another click on "Demo Benutzer Anmelden"
    if (this.$route.meta && this.$route.meta.autoDemo) {
      this.autoDemo = true
      this.submitDemoForm()
    }
  },
  computed: {
    // ...mapGetters([
    //  'company'
    // ]),
    organizations () {
      if (this.showOrganizationPopup) {
        return [{ code: 'CHL', name: 'Clever Home Labs GmbH' }, { code: 'MF', name: 'Matthias Fricke' }, { code: 'TB', name: 'Thomas Bauche' }]
      }
      return []
    }
  },
  methods: {
    loadCompanyValues () {
      // this.currentCompany = { logo: 'CHL_Logo.png', name: 'Clever Home Labs' }
      this.$store.dispatch('getCompanyData')
        .then(() => {
          /* eslint-disable no-console */
          console.log('getCompanyData Login')
          /* eslint-disable no-console */
          console.log(this.$store)
          this.currentCompany = this.$store.getters.company
          /* eslint-disable no-console */
          console.log(this.currentCompany)
        })
        .catch(() => {
          /* eslint-disable no-console */
          console.log('could not get company data')
        })
    },
    submitDemoForm () {
      const params = { organization: 'DEMO', username: 'merick', password: 'geheim' }
      authenticationService.authenticate(params).then(() => {
        this.$router.push({ name: 'home' })
      }).catch((error) => {
        // auto entry failed -> fall back to the regular login page + error
        this.autoDemo = false
        let message = error.message
        if (message === 'Invalid credentials') {
          message = this.$t('loginPage.server.invalidCredentials')
        } else if (message === 'Authentication failure') {
          message = this.$t('loginPage.server.authenticationFailure')
        }
        this.errorMessage = message
      })
    },
    submitForm () {
      this.v$.$touch()
      if (this.v$.$invalid) {
        return
      }

      authenticationService.authenticate(this.form).then(() => {
        this.$router.push({ name: 'home' })
      }).catch((error) => {
        let message = error.message
        if (message === 'Invalid credentials') {
          message = this.$t('loginPage.server.invalidCredentials')
        } else if (message === 'Authentication failure') {
          message = this.$t('loginPage.server.authenticationFailure')
        }
        this.errorMessage = message
      })
    },
    passwordForgotten () {
      this.showForgottenModal = true
    },
    closeForgottenModal () {
      this.showForgottenModal = false
    },
    clearError () {
      this.errorMessage = ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .links {
    margin: 30px 0 50px 0;
    text-align: center;
  }

  .form {
    padding: 1.5rem;
    background-color: #fff;
    border-radius: 0.5rem;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    margin-left: auto;
    margin-right: auto;
  }

  .forgotten {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .pricing-link {
    text-align: center;
    margin-top: 1.25rem;
    font-size: 0.85rem;

    a {
      color: #6695C2;
      text-decoration: none;
      &:hover { text-decoration: underline; }
    }
  }

  .btn-grey-border {
    color: darkgrey;
    background-color: white;
    border-color: darkgrey;
    border-radius: 0;
    font-size: 0.8rem;
    padding: .375rem .2rem;
    width: 11rem;
  }

</style>
